var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rewards-page"},[_c('div',{staticClass:"rewards-container"},[_c('div',{staticClass:"head"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t(`${_vm.i18nPrefix}.label.rewards`)))])]),_c('div',{staticClass:"content"},[(_vm.isElcEmployee)?_c('Elc'):_c('Common',{ref:"rewards"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }